import { UseFormReturn } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Checkbox } from '@factorialco/f0-react'
import { F0Text } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { AutoScheduleSchemaType } from 'modules/shift_management/lib/forms/AutoSchedule/schema'

interface Props {
  form: UseFormReturn<AutoScheduleSchemaType>
}
const Rules = observer(({ form }: Props) => {
  const handleCheck = (
    rule: (typeof AutomaticScheduleRules)[keyof typeof AutomaticScheduleRules]['key']
  ) => {
    const currentField = form.getValues(rule)
    form.setValue(rule, !currentField)
  }

  const AutomaticScheduleRules = {
    AGREEMENT_HOURS: {
      key: 'agreementHours',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.agreement_hours'),
    },
    REST_DAYS_PER_WEEK: {
      key: 'restDaysPerWeek',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.rest_days_per_week'),
    },
    MIN_REST_HOURS_BETWEEN_SHIFTS: {
      key: 'restHoursBetweenShifts',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.min_rest_hours'),
    },
    MAX_WORK_HOURS_PER_DAY: {
      key: 'maxWorkHoursPerDay',
      label: i18n.t('shift_management.coverage_section.automation.modal.rules.max_work_hours'),
    },
  } as const

  return (
    <Box gap="s8" flexDirection="column">
      <F0Text
        variant="label"
        content={i18n.t('shift_management.coverage_section.automation.modal.rules.title')}
      />

      {Object.entries(AutomaticScheduleRules).map(
        ([idx, rule]: [
          string,
          (typeof AutomaticScheduleRules)[keyof typeof AutomaticScheduleRules]
        ]) => (
          <Box key={idx} gap="s12" flexDirection="row" onClick={() => handleCheck(rule.key)}>
            <F0Checkbox checked={form.getValues(rule.key)} />
            {rule.label}
          </Box>
        )
      )}
    </Box>
  )
})

export { Rules }
